import React, { useCallback, useContext } from 'react';
import { TriageActionStatus, type TriageRun } from 'src/graphql/entities/conversation-triage-run';
import { TriageRunContext } from './triage-run-context';
import { TriageRunRowView } from './triage-run-row-view';

export const TriageRunRow = React.memo(({ item }: { item: TriageRun }) => {
  const { isResolving, accept, dismiss, retry } = useContext(TriageRunContext)!;

  const handleAcceptAll = useCallback(() => {
    item.groups.suggested
      .filter((action) => action.status === TriageActionStatus.Suggested)
      .forEach((action) => {
        void accept(action.id);
      });
  }, [accept, item.groups.suggested]);

  const handleAccept = useCallback((actionId: string) => void accept(actionId), [accept]);
  const handleDismiss = useCallback((actionId: string) => void dismiss(actionId), [dismiss]);
  const handleRetry = useCallback((actionId: string) => void retry(actionId), [retry]);

  return (
    <TriageRunRowView
      run={item}
      isResolving={isResolving}
      onAccept={handleAccept}
      onDismiss={handleDismiss}
      onRetry={handleRetry}
      onAcceptAll={handleAcceptAll}
    />
  );
});
TriageRunRow.displayName = 'TriageRunRow';
